import React from "react";
import { connect } from "react-redux";

import { doGetAllPartners, doCreatePartner, doUpdatePartner } from "../stores/thunk";
import { selectAllPartners } from "../stores/slice";

export default Component => {
  class Container extends React.Component {
    render() {
      return <Component {...this.props} />;
    }
  }
  function mapStateToProps(state) {
    return {
      isFetching: state.partner.isFetching,
      partners: selectAllPartners(state),
    };
  }

  return connect(mapStateToProps, {
    doGetAllPartners,
    doCreatePartner,
    doUpdatePartner,
  })(Container);
};
